import React from 'react';
import final from "../assets/img/final.png"
import logo from "../assets/img/hamyarii.png"


function HeaderLogin() {

  return (
  <div>
    <header>
      <div  className="container-fluid rgc-header-login g-0">
        <div className='row justify-content-center g-0' >

          <div className="col-2 col-md-3">
            <div className="rgc-logo mx-2">
              <img src={logo} className="ms-auto" alt='logo' />
            </div>
          </div>

          <div  className="col-7 col-md-6 text-center">
            <div className="rgc-logo">
              <span>سامانه خدمات الکترونیکی سازمان همیاری</span>
              <span>سازمان همیاری شهرداری های استان مازندران</span>
              
            </div>
          </div>

          <div  className="col-3 col-md-3 text-start">
            <div className="rgc-header-parent">
             <img src={final} alt='leader'/>
            </div>
          </div>

        </div>
      </div>
    </header>
  </div>
  )
}

export default HeaderLogin;
